import { render, staticRenderFns } from "./UsersImgContainer.vue?vue&type=template&id=ceee7f00&scoped=true&"
import script from "./UsersImgContainer.vue?vue&type=script&lang=ts&"
export * from "./UsersImgContainer.vue?vue&type=script&lang=ts&"
import style0 from "./UsersImgContainer.vue?vue&type=style&index=0&id=ceee7f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceee7f00",
  null
  
)

export default component.exports